import {BaseDTO} from '../../common/models/BaseDTO';
import {NameValueDTO} from '../../common/models/NameValueDTO';
import {IssueTicketDetailsLinkDTO} from './IssueTicketDetailsLinkDTO';
import {IssueTicketAttachmentsLinkDTO} from './IssueTicketAttachmentsLinkDTO';

export class IssueTicketDTO extends BaseDTO {
  issueTicketId: bigint;
  name: string;

  // Note: Added union type as IssueTicketCase was not working with e.g "YYYY-MM-DDT00:00:00.000Z" format.
  startDate: Date | number;
  endDate: Date | number;
  dueDate: Date | number;
  reporter: NameValueDTO;
  assignee: NameValueDTO;
  status: NameValueDTO;
  resolution: NameValueDTO;
  priority: NameValueDTO;
  module: NameValueDTO;
  issueTicketDetailsLink: IssueTicketDetailsLinkDTO[];
  issueTicketAttachmentsLink: IssueTicketAttachmentsLinkDTO[];
}
